const module = {
  namespaced: true,
  registered: false,
  actions: {
    async getReviews({ commit }, params) {
      try {
        const { data } = await this.$http.post('/product/v1/review/me', params)
        return data
      } catch (err) {
        console.log(err)
      }
    },
  },
}

export default module
